import React from "react";
import { SvgHandler } from "../../svg-handler/svg-handler";
import facebookIcon from "../../../../assets/icons/social/facebook.svg";
import twitterIcon from "../../../../assets/icons/twitter.svg";
import linkedInIcon from "../../../../assets/icons/linkedin.svg";
import whatsappIcon from "../../../../assets/icons/social/whatsapp-share.svg";

export function getSocialShareData({
  fbUrl,
  twitterUrl,
  linkedinUrl,
  whatsappUrl,
  height = "24",
  width = "24",
  color
}) {
  return [
    {
      name: "facebook",
      url: fbUrl,
      icon: <SvgHandler width={width} clazzName="facebook" height={height} xlinkHref={facebookIcon} />
    },
    {
      name: "twitter",
      url: twitterUrl,
      icon: <SvgHandler width={width} clazzName="twitter" height={height} xlinkHref={twitterIcon} />
    },
    {
      name: "linkedin",
      url: linkedinUrl,
      icon: <SvgHandler width="28" clazzName="linkedin" height={height} xlinkHref={linkedInIcon} />
    },
    {
      name: "whatsapp",
      url: whatsappUrl,
      icon: <SvgHandler width={width} clazzName="whatsapp-share" height={height} xlinkHref={whatsappIcon} />
    }
  ];
}
